import { AlertTriangle } from "lucide-react";

import {
  Banner,
  BannerAction,
  BannerIcon,
  BannerTitle,
} from "@components/ui/banner";

type TranscriptionFailedBannerProps = {
  /** A retry is being started. */
  isRetrying?: boolean;
  onRetry: () => void;
};

/**
 * Shown on the Scribe page when the last transcription failed but the server
 * kept a copy of the recording (MDRS-575), so it can be re-run without the
 * doctor uploading it again.
 */
export const TranscriptionFailedBanner = ({
  isRetrying = false,
  onRetry,
}: TranscriptionFailedBannerProps) => (
  <Banner variant="destructive" inset role="alert" className="flex-wrap">
    <BannerIcon>
      <AlertTriangle />
    </BannerIcon>
    <BannerTitle className="min-w-48 space-y-0.5">
      <span className="block text-sm font-semibold text-foreground">
        {"The last recording couldn't be transcribed"}
      </span>
      <span className="block text-xs font-normal text-foreground-muted">
        A copy was saved, so you can try again without uploading it again.
      </span>
    </BannerTitle>
    <BannerAction variant="default" isLoading={isRetrying} onClick={onRetry}>
      Retry transcription
    </BannerAction>
  </Banner>
);
